import 'src/base';
import 'src/categories/shop_by_nav';
import 'src/categories/cat_card';

const ecommerce = {
  item_list_name: "all_products"
}

ProductCatalog.gtmEcomEvent('products_categories', ecommerce);
